/* 封装axios用于发送请求 */
import axios from 'axios'
import { Toast } from 'vant'
import store from '@/store'

// 创建一个新的axios实例
const instance = axios.create({
  baseURL: 'https://'+store.state.baseUrl+'/index',
  timeout: 500000
})
// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  // Toast.loading({
  //   message: '请求中...',
  //   forbidClick: true,
  //   loadingType: 'spinner',
  //   duration: 0
  // })
  const token = store.getters.token
  if (token) {
    config.headers['Access-Token'] = token
    config.headers.platform = 'H5'
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  // 2xx范围内的状态码都会触发该函数。
  // 对响应数据做点什么(默认axios会多包装一层data，需要响应拦截器中处理一下)
  const res = response.data
  if (res.status !== 200) {
    // Toast(res.message)
    return res
  } else {
    // 清除 loading 中的效果
    Toast.clear()
  }
  return res
}, function (error) {
  // 对响应错误做点什么
  // 超出 2xx范围的状态码都会触发该函数
  return Promise.reject(error)
})

export default instance
